export enum ValidationErrorType {
  TooLong = 'maxlength',
  TooShort = 'minlength',
  ValueMissing = 'required',
  PatternUnmatch = 'invalid.format',
  InvalidValue = 'invalid.value',
  AccPrefix = 'invalid.prefix',
  FileSize = 'attachment.maxSizeExceeded',
  FileName = 'attachment.fileName',
  FileType = 'attachment.invalidExtension',
  InvalidAccountNumber = 'invalid.wrong-account-format',
  BankCode = 'invalid.bankCode',
  PersonalId = 'invalid.birthNumber.modulo',
  Min = 'number.min',
  Max = 'number.max'
}
